const unifyTranslation = (value: string | string[]) => (Array.isArray(value) ? value : [value, value]);

export default unifyTranslation;
